<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-select
          v-model="filter.company"
          :items="$store.getters['admin/companies']"
          item-text="name"
          item-value="idx"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      group-by="company"
      :page.sync="currentPage"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:group.header="{group,headers,isOpen,toggle}">
        <td :colspan="headers.length">
          <v-btn icon @click="toggle">
            <v-icon>{{isOpen?'mdi-minus':'mdi-plus'}}</v-icon>
          </v-btn>
          {{$store.getters['admin/company'](group).name}}
        </td>
      </template>
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({rules:{}})" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
      <template v-slot:item.company="{item}">{{$store.getters['admin/company'](item.company).name}}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>{{$t("admin.user")}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="user_errors"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>
            <v-text-field
              v-model="item.control_phone"
              clearable
              :rules="[v=>v==null || (/^\d+$/g.test(v) && v.length==8)||$t('error.phone')]"
              :placeholder="$t('fields.control_phone_ph')"
            ></v-text-field>
            <v-select v-model="item.status" :items="$t('recStatus')"></v-select>
            <v-select
              v-model="item.company"
              :items="$store.getters['admin/companies']"
              item-text="name"
              item-value="idx"
            ></v-select>
            <v-checkbox v-model="item.rules.admin" :label="$t('fields.isAdmin')"></v-checkbox>
            <v-text-field v-model="item.pass" :label="$t('fields.newpassword')"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="remove" color="primary">{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
export default {
  name: "Users",
  mixins: [commonmixin],
  data() {
    return {
      user_errors: "",
      d_edit: false,
      filter: {
        company: null,
      },
      item: {
        rules: {},
      },
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 100,
        },
        {
          text: this.$t("fields.user_name"),
          value: "name",
        },
        {
          text: this.$t("fields.company"),
          value: "company",
          filter: (v) => {
            return !this.filter.company || this.filter.company == v;
          },
        },
        {
          text: this.$t("fields.created"),
          value: "created",
        },
        {
          text: this.$t("fields.updated"),
          value: "updated",
        },
        {
          text: this.$t("fields.status"),
          value: "status",
        },
      ],
    };
  },
  methods: {
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.users.indexOf(i);
      this.item.pass = null;
    },
    remove() {
      this.$store.dispatch("admin/DELETE_USER", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      if (this.item.pass)
        this.item.pass = this.$CryptoJS.enc.Base64.stringify(
          this.$CryptoJS.SHA256(this.item.pass)
        );

      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_USER", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.users.find((e) => {
          return e.name == this.item.name;
        });
        if (prev) {
          this.user_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_USER", this.item)
            .then((response) => {
              if (response == 0) {
                this.user_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
  },
  computed: {
    users() {
      return this.$store.getters["admin/users"];
    },
  },
  mounted() {
    if (!this.$store.getters["admin/isUsers"]) {
      this.$store.dispatch("admin/LOAD_USERS");
    }
    if (!this.$store.getters["admin/isCompanies"]) {
      this.$store.dispatch("admin/LOAD_COMPANIES");
    }
  },
};
</script>

<style>
</style>